/*
 *   Copyright (c) 2021 vlinder Labs Private Limited
 *   All rights reserved.
 *   This software is proprietary of Vlinder Labs Pvt. Ltd and can not be distributed / used for any purpose outside of Vlinder Labs Pvt. Ltd without explicit written consent from the copyright owner.
 */

import {
    IAgentPlugin,
    IPluginMethodMap,
  } from "@vlinder-web/plugin-agent-service-react";
  // import config from "../config/issueCredential.config.json";
  // import notification from "../config/notifications.config.json";
  import axios from "axios";
  import { GraphqlServerModule } from "@vlinder-web/graphql-server-module-react";
  import { UPDATE_PORTFOLIO } from "../graphql";
  import { VApplication } from "../../../application";
  import {useCollection} from "../provider";
  
  const getGraphQLModule = () => {
    const app = VApplication.getInstance();
    return app.getSync("services.GraphqlServerModule") as GraphqlServerModule;
  };
  
  export interface IUpdatePortfolioStatusMethods extends IPluginMethodMap {
    getUpdatePortfolioStatus(args: any): Promise<any>;
  }
  
  export interface UpdatePortfolioStatusProps {
    status:string;
    reason?:any;
  }
  
  export class UpdatePortfolioStatusService implements IAgentPlugin {
    readonly methods: IUpdatePortfolioStatusMethods;
    constructor() {
      this.methods = {
        getUpdatePortfolioStatus: this.getUpdatePortfolioStatus.bind(this),
      };
    }
  
    async getUpdatePortfolioStatus(args: UpdatePortfolioStatusProps) {
      console.log(`args in issue credential`, args);
      const {portfolioTempId} = useCollection();
      const graphqlModule = getGraphQLModule();
      const client = graphqlModule.getClient("graphql-gateway");

      try {
        // console.log('args in update service', args);
        if (client) {
          const res = await client.mutate({
            mutation: UPDATE_PORTFOLIO,
            variables: {
              filter:{
                uuid:portfolioTempId,
              },
              update:{
                state: args?.status
              }
           
             
            },
            fetchPolicy: "no-cache",
          });
          if (res?.data?.updateStudPortfolio) {
            console.log(`Update status`, res);
            return res?.data?.updateStudPortfolio;
          }
        }
      } catch (err: any) {
        // console.log("error in issue credential", err?.message);
        throw err;
      }
    }
  }
  